import { formatToCLP } from '../formatToCLP';

const MILLIONS_SIGN = 'M';

const showAsMillions = (
  value: number,
  decimal = 2,
  options?: Intl.NumberFormatOptions,
) => {
  const formattedValue = formatToCLP(value, {
    minimumFractionDigits: decimal,
    ...options,
  });

  return `${formattedValue} ${MILLIONS_SIGN}`;
};

export { MILLIONS_SIGN, showAsMillions };
